export default __webpack_public_path__ + "static/media/Larissa_Maloney_AHV_In_Moms_We_Trust.6b4db7ea.jpg";